export const ROWS_PER_PAGE = 10;
export const CURRENT_PAGE_FIELD = 'currentPage';
